var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multicols",style:(_vm.containerStyle)},[_c('BlocksDispatcher',{style:(_vm.leftBlockStyle),attrs:{"blocks":_vm.model.blocksLeft}}),_c('BlocksDispatcher',{attrs:{"blocks":_vm.model.blocksRight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }